import React, { Fragment } from "react";
import FadeInUp from "../../shared/animations/fadeInUp";
import VisibilitySensor from 'react-visibility-sensor';


export default function OutroBlock() {
  return (
    <Fragment>
      <VisibilitySensor partialVisibility={true}>
        {({ isVisible }) =>
          <Fragment>
            <div className="col-md-12 mb-5 mb-md-0">
              <FadeInUp once fadeIn={isVisible ? true : false}>
                <div className="mb-5 pb-2">
                  <h3>Wat mag je verwachten?</h3>

                  <h4>Persoonlijke zorg</h4>
                  <p>Elke behandeling is afgestemd op jouw unieke behoeften, zodat je verzekerd bent van een op maat gemaakt pad naar genezing en balans.</p>

                  <h4>Holistische genezing</h4>
                  <p>Ik richt me op het behandelen van de hoofdoorzaak van je symptomen, niet alleen op het maskeren ervan, voor blijvend welzijn.</p>

                  <h4>Bewezen resultaten</h4>
                  <p>Patiënten melden verlichting van pijn, stress, slapeloosheid, spijsverterings- en gynaecologische problemen, enz. en meer na één of slechts een paar sessies.</p>

                  <h4>Diepgaande expertise</h4>
                  <p>Met jaren training en ervaring en honderden behandelde patiënten combineer ik traditionele wijsheid met moderne kennis voor optimale resultaten.</p>

                  <h4>Veilige en ontspannende sfeer</h4>
                  <p>Bij mij kun je je problemen loslaten en jezelf zijn. Genezing begint met vertrouwen.</p>

                  <h4>Nauw contact</h4>
                  <p>Altijd beschikbaar om je twijfels of vragen over de behandeling en je gezondheid op te lossen.</p>
                </div>
              </FadeInUp>
            </div>
          </Fragment>
        }
      </VisibilitySensor>
    </Fragment>
  );
}
